import {
    Button,
    Modal,
    ModalContent,
    ModalBody,
    useDisclosure
} from "@heroui/react";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {usePageLeave} from "@mantine/hooks";

const LeavePageModal = ({hasChanges = false}) => {
    const navigate = useNavigate();
    const {isOpen, onOpen, onOpenChange} = useDisclosure();

    usePageLeave(() => {
        if (hasChanges) {
            onOpen();
        }
    });

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (hasChanges) {
                event.preventDefault();
                event.returnValue = '';
                return '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [hasChanges]);


    return (
      <>
          <Button
            onPress={() => {
                if (hasChanges) {
                    onOpen();
                } else {
                    navigate('/app');
                }
            }}
            variant=""
            className="">
              <i className="hgi-stroke hgi-arrow-left-02 font-bold md:text-3xl text-black"></i>
          </Button>

          <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            isDismissable={false}
            hideCloseButton={true}
            backdrop="blur"
            size="md"
            classNames={{
                base: "overflow-hidden rounded-3xl border border-[#12131714] bg-white shadow-2xl",
                body: "p-0",
            }}
          >
              <ModalContent>
                  {(onClose) => (
                    <ModalBody>
                        {/* Hero band — amber "caution" themed with a pulsing badge */}
                        <div className="relative overflow-hidden bg-gradient-to-br from-[#f59e0b] via-[#f5a623] to-[#fbbf24] px-8 pt-9 pb-12">
                            <div className="pointer-events-none absolute -top-10 -right-8 h-32 w-32 rounded-full bg-white/15 blur-2xl" />
                            <div className="pointer-events-none absolute -bottom-12 -left-6 h-32 w-32 rounded-full bg-white/10 blur-2xl" />

                            <div className="relative flex flex-col items-center text-center">
                                <div className="relative grid h-16 w-16 place-items-center">
                                    <span className="absolute inset-0 rounded-2xl bg-white/30 animate-ping" />
                                    <span className="relative grid h-16 w-16 place-items-center rounded-2xl bg-white/20 backdrop-blur-sm ring-1 ring-white/40">
                                        <i className="hgi hgi-stroke hgi-floppy-disk text-3xl text-white" />
                                    </span>
                                </div>
                                <h2 className="mt-4 text-xl font-semibold text-white">Wait — you have unsaved changes</h2>
                                <p className="mt-1 max-w-sm text-sm font-light text-white/85">
                                    Leave now and your latest edits to this project won&apos;t be saved.
                                </p>
                            </div>
                        </div>

                        {/* Reassurance note */}
                        <div className="px-6 pt-5">
                            <div className="flex items-start gap-3 rounded-2xl border border-[#12131714] bg-[#fcfcfd] p-4">
                                <i className="hgi hgi-stroke hgi-idea-01 mt-0.5 text-lg text-[#f59e0b]" />
                                <p className="text-sm font-light leading-relaxed text-slate-500">
                                    Tip: go back and hit <strong className="font-semibold text-slate-700">Save</strong> to keep your work, then leave whenever you like.
                                </p>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="flex justify-end gap-3 px-6 py-5">
                            <Button
                              onPress={onClose}
                              variant="bordered"
                              className="h-11 rounded-xl border-1 border-[#00000014] bg-[#c8ceda4d] px-6 text-sm font-medium text-slate-700 hover:border-slate-700">
                                Stay & keep editing
                            </Button>
                            <Button
                              onPress={() => {
                                  navigate('/app');
                                  onClose();
                              }}
                              className="h-11 rounded-xl bg-[#ef4444] px-6 text-sm font-medium text-white shadow-lg shadow-[#ef444440] transition hover:opacity-95">
                                <i className="hgi hgi-stroke hgi-logout-03 text-[15px]" /> Leave anyway
                            </Button>
                        </div>
                    </ModalBody>
                  )}
              </ModalContent>
          </Modal>
      </>
    )
};

export default LeavePageModal;